import Cleave from 'cleave.js' ;

export function inputBirthday(){
  new Cleave('.input-birthday', {
    date: true,
    delimiter: '.',
    datePattern: ['d', 'm', 'Y'],
  });
}



// WEBPACK FOOTER //
// ./scripts/components/input-birthday.js